import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { ReportsTable } from "./table";
import { setQueries } from "../../../../redux/actions/reports/reportsAction";

const CollapsibleTableReport = ({ columns, data }) => {

  const dispatch=useDispatch()
  const [toToggle, setToToggle] = React.useState(null)
  const [expanded, setExpanded] = React.useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [allExpanded, setAllExpanded] = React.useState(false);
  const [allCollapsed, setAllCollapsed] = React.useState(true);

  React.useEffect(() => {
    if (typeof toToggle === "number") {
      let arr = expanded;
      arr[toToggle] = !arr[toToggle];
      setExpanded(arr);
      setToToggle(null);
      expanded.includes(false) ? setAllExpanded(false) : setAllExpanded(true);
      expanded.includes(true) ? setAllCollapsed(false) : setAllCollapsed(true);
    }
  }, [toToggle]);

  return (
    <div className="classes-page-container">

      <div className="collapsible-table-container">
        <Row className="single-day-row">
          <Col xs={10}>
            <span className="single-day-day-text">Day and Date</span>
          </Col>
          <Col xs={2} className="d-inline-flex justify-content-end">
            <span
              className="purplish-link"
                  onClick={
                allExpanded
                  ? () => {
                      setAllCollapsed(true);
                      setAllExpanded(false);
                      setExpanded([false,false,false,false,false, false, false]);
                    }
                  : () => {
                      setAllExpanded(true);
                      setAllCollapsed(false);
                      setExpanded([true, true, true, true, true, true, true]);
                    }
              }
            >
              {allExpanded ? "Collapse All" : "Expand All"}
            </span>
          </Col>
        </Row>
        {data.map((el, idx) => {
          return (

            <Row
              className={`single-day-row ${expanded[idx] ? "expanded-row" : "collapsed-row"
                }`}
            >
              <Col xs={11}>
                <span className="single-day-day-text">
                  {el}
                </span>
              </Col>
              <Col
                xs={1}
                className="p-2 row-toggler"
                onClick={() => { 
                  setToToggle(idx) 
                  if(!expanded[idx]){ dispatch(setQueries({day:el}))}
                  }}
              >
                {expanded[idx] ? (
                  <img src={require(`../../../../assets/images/collapse.svg`)} />
                ) : (
                  <img src={require(`../../../../assets/images/collapse.svg`)} />
                )}
              </Col>
              <Col xs={12} >
                {expanded[idx] &&
                  <ReportsTable columns={columns} />
                }
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};


export default CollapsibleTableReport;
